import { render } from "./ExhibitionArea.vue?vue&type=template&id=2600e26b&scoped=true"
import script from "./ExhibitionArea.vue?vue&type=script&lang=js"
export * from "./ExhibitionArea.vue?vue&type=script&lang=js"

import "./ExhibitionArea.vue?vue&type=style&index=0&id=2600e26b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2600e26b"]])

export default __exports__